/* eslint-disable no-unused-vars */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

// import styled, { css, keyframes } from 'styled-components';
import styled, { css } from 'styled-components';
// import { fadeInDown, fadeOutUp } from 'react-animations';
import Close from '../../../../component/button/Close';

const HEIGHT = 36;

// const keyframeFadeInDown = keyframes`${fadeInDown}`;
// const keyframeFadeOutUp = keyframes`${fadeOutUp}`;

const opacAnimation = css`
  transition: 0.1s opacity;
  opacity: ${props => (props.isHidden ? 0 : 1)};
`;
// const kfAnimation = css`
//   animation: ${props => (props.isHidden ? null : `0.2s ${keyframeFadeInDown}`)};
// `;
// ${opacAnimation};
// ${kfAnimation};
const animation = css`
  ${opacAnimation};
`;

const StyledFixedBar = styled.div`
  ${props => (props.animation ? animation : null)};

  position: ${props => (props.fixed ? 'fixed' : 'absolute')};
  top: 0;
  left: 0;
  z-index: 1002;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  margin: 0;
  padding-right: 16px;
  width: 100%;
  height: ${HEIGHT}px;
  background: #bf0000;

  > span {
    /* to override close-button's width/height */
    width: 14px;
    height: 14px;
  }
`;

const HeaderCloseBar = forwardRef(
  (
    {
      onClick,
      animation = true,
      fixed = true,
      hidden = true,
      'data-testid': testId = 'HeaderCloseBar',
    },
    ref
  ) => (
    <StyledFixedBar
      onClick={onClick}
      animation={animation}
      fixed={fixed}
      isHidden={hidden}
      innerRef={ref}
      data-testid={testId}
    >
      <Close color={'white'} />
    </StyledFixedBar>
  )
);

export default HeaderCloseBar;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/inquiry/node/header/HeaderCloseBar.js